module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateRole()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.confirmUpdate')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetCheck()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.reset')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "gTopMg gSgLeftBtn",
    attrs: {
      "show-checkbox": "",
      "data": _vm.resultData,
      "props": _vm.defaultProps,
      "node-key": "menuId",
      "default-expand-all": "",
      "expand-on-click-node": false
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "width": "60%",
      "margin-top": "10px"
    },
    attrs: {
      "label-position": "left",
      "label-width": "90px"
    }
  }, [_c('el-form-item')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aabd8b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/role-update.vue
// module id = 997
// module chunks = 0